<script>

  import 'swiper/dist/css/swiper.css'

  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import { Carousel3d, Slide } from 'vue-carousel-3d';
  import TextileSlide  from './slide.vue';


  export default {

    props:['slide'],
    data:function () {
      return  {
        swiperOption: {
          slidesPerView: 1,
              loop: true,
              speed: 1000,
              autoplay: {
                  delay: 3000
              },
              pagination: {
                  el: '.swiper-pagination',
                  type: 'bullets',
                  clickable: true
              }
        }
      }
    },
    components: {
        Carousel3d,
        Slide,
        swiper,
        swiperSlide,
        'TextileSlide':TextileSlide
    },
    // computed: {
    //   swiper() {
    //     return this.$refs.reviews-swiper.swiper
    //   }
    // }

  };
</script>
<template>

    <div class="vue-reviews">
        <div class="reviews__slider" id="reviews-slider" v-if="$mq === 'lg'||$mq === 'md'">
            <carousel-3d :perspective="0" :width="600" :height="500" :space="200" :autoplay="true" :autoplay-timeout="10000" :autoplay-hover-pause="true" :clickable="true" :display="3" :controls-visible="true" :controls-width="30" :controls-height="30">
                <slide  v-for="(model,key) in slide" :index="key" v-bind:key="key">
                    <TextileSlide  v-bind:title="model.title" v-bind:image="model.image" v-bind:content="model.content" v-bind:key="key"/>
                </slide>
            </carousel-3d>
        </div>

        <swiper id="reviews-sliderPortrait" :options="swiperOption" ref="reviews-swiper" v-if="$mq === 'sm'">
            <swiper-slide v-for="(model,key) in slide" :index="key" v-bind:key="key">
                <TextileSlide  v-bind:title="model.title" v-bind:image="model.image" v-bind:content="model.content" v-bind:key="key"/>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>


</template>